<!-- 金刚区Icon -->
<template>
  <div :class="innerBarStyle.show ? 'icon-list icon-list-scroll' : 'icon-list'">
    <div class="icons" @scroll="handleScroll">
      <div
        v-for="(item, idx) in data"
        :key="idx"
        class="icon-item"
        :style="{ minWidth: `calc((100vw - 16px) / ${columnNumber})` }"
        @click="handleIconClick(item)"
      >
        <div class="icon"><img :src="item.image" alt=""></div>

        <div class="icon-name"><span>{{ item.title }}</span></div>
      </div>
    </div>

    <div class="sidebar-box" v-show="innerBarStyle.show">
      <div class="small-sidebar">
        <div class="inner-bar" :style="{ width: innerBarStyle.width, left: innerBarStyle.left }" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface IProps {
  isAll?: boolean,
  columnNumber?: number
  data: { title: string, image: string, type: string, data: string }[]
  /** 首页金刚区：跳转时写入 Banner|mainIconBanner 埋点 source */
  trackHomeIconSource?: boolean
}
interface IInnerBarStyle { width: string, left: string, show: boolean }

const props = withDefaults(defineProps<IProps>(), {
  isAll: true,
  columnNumber: 5,
  data: () => new Array(5).fill({ title: '', image: '', type: '', data: '' }),
  trackHomeIconSource: false
})

const { $throttle, $cmsGoTo } = useNuxtApp()
const innerBarStyle = reactive<IInnerBarStyle>({ width: '', left: '0%', show: false })

const initScrollBar = async() => {
  await new Promise(r => setTimeout(r, 150))

  const innerWidth = (props.columnNumber / props.data.length) * 100
  if(innerWidth < 100) {
    innerBarStyle.width = `${innerWidth}%`
    innerBarStyle.show = true
  }
}
watch(() => props.data, initScrollBar)
onMounted(initScrollBar)

const handleScroll = $throttle((e: Event) => {
  const target = e.target as HTMLElement
  const { scrollLeft, scrollWidth } = target
  
  innerBarStyle.left = `${scrollLeft / scrollWidth * 100}%`
}, 10)

const handleIconClick = (item: { title: string, type: string, data: string }) => {
  if (props.trackHomeIconSource) {
    $cmsGoTo(item.type, item.data, {
      trafficSourceScene: 'homeMainIconBanner',
      sourceValue: item.title
    })
    return
  }
  $cmsGoTo(item.type, item.data)
}
</script>

<style lang='scss' scoped>
.icon-list {
  position: relative;
  padding: 15px 0;
  background-color: #fff;
  height: 170px;
  overflow: hidden;
  border-radius: 10px;
}
.icon-list-scroll{
  height: 200px;
}

.icons{
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  &::-webkit-scrollbar {
    display: none
  }
  .icon-item{
    text-align: center;
    .icon{
      padding: 10px 0;
      img{
        width: 65px;
        height: 65px;
      }
    }
    .icon-name{
      font-size: 22px;
      height: 56px;
      line-height: 28px;
      @include ellipsisMultiline(2);
    }
  }
}
.sidebar-box{
  text-align: center;
  margin-top: -8px;
  .small-sidebar{
    display: inline-block;
    position: relative;
    width: 100px;
    height: 6px;
    background-color: #f5f5f5;
    border-radius: 6px;
    overflow: hidden;
    .inner-bar{
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      border-radius: 6px;
      background-color: var(--default_color);
      width: 50px;
    }
  }
}
</style>
